import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { ZendeskVehicleSync } from "../../util/vehicle/ZendeskVehicleSync";

/*
   * browser-state specific endpoints
   */
export function saveVehicleToBrowserState(vehicle: IVehicle) {
  const { make, model, year } = vehicle;
  ZendeskVehicleSync({ make, model, year });
  return axios.post<void>("/save-vehicle-v3", { ...vehicle });
}
